import { BasicUserInfoResponseType } from "../../../api";
import { DELEGATION_UNTERNEHMENSDATEN } from "../../../constants/constants";

const getDelegationFilters = (userInfo: BasicUserInfoResponseType): string[] => {
  if (userInfo.authenticatedUserRoleId && userInfo.delegationFilters) {
    return userInfo.delegationFilters[userInfo.authenticatedUserRoleId] ?? [];
  } else {
    return [];
  }
};

export const hasNoDelegationRestrictions = (userInfo: BasicUserInfoResponseType): boolean => {
  return getDelegationFilters(userInfo).length === 0;
};

export const hasUnternehmenDelegationRestriction = (userInfo: BasicUserInfoResponseType): boolean => {
  return (
    hasNoDelegationRestrictions(userInfo) || getDelegationFilters(userInfo).indexOf(DELEGATION_UNTERNEHMENSDATEN) >= 0
  );
};
